// Third-party libraries
import React from "react";
import { Link as DomLink } from "react-router-dom";
import Stack from "@mui/material/Stack";
import HelpIcon from "@mui/icons-material/Help";

// Local modules
import StringConstants from "../../../utils/constants";
import {
  USFlagIcon,
  ASIcon,
  SCSIcon,
  ConflictFreeIcon,
  CanadaIcon,
  RecycleIcon,
} from "../../Icons";

export default function DiamondIconStrip({ diamond, show_text }) {
  const size = StringConstants.SIZE_MEDIUM;

  const {
    DIAMOND_SOURCE_CONFLICT_FREE,
    DIAMOND_SOURCE_CONFLICT_FREE_DISTINCT,
    DIAMOND_SOURCE_CANADIAN,
    DIAMOND_SOURCE_RECYCLED,
  } = StringConstants;

  const getHelpLink = (gemstone) => {
    switch (gemstone) {
      case "True American Sapphires":
        return "/sub-landing/Sapphires";
      case "Brazil Tourmalines":
        return "/sub-landing/Tourmalines";
      case "African Treasures":
        return "/sub-landing/African-Treasures";
      default:
        return "/sub-landing/Diamond-Sources";
    }
  };
  return (
    <Stack
      direction="row"
      spacing={1}
      justifyContent="center"
      alignItems="center"
      sx={{ paddingLeft: "0.5rem" }}
    >
      {(diamond.DiamondSource === "Harmony US Lab Grown" ||
        diamond.USGrown === "Y") && (
        <USFlagIcon size={size} show_text={show_text} />
      )}

      {diamond.AsGrown === "Y" && <ASIcon size={size} show_text={show_text} />}

      {diamond.ScsGrower === "Y" && (
        <SCSIcon size={size} show_text={show_text} />
      )}

      {(diamond.DiamondSource === DIAMOND_SOURCE_CONFLICT_FREE ||
        diamond.DiamondSource === DIAMOND_SOURCE_CONFLICT_FREE_DISTINCT) && (
        <ConflictFreeIcon size={size} show_text={show_text} />
      )}

      {diamond.DiamondSource === DIAMOND_SOURCE_CANADIAN && (
        <CanadaIcon size={size} show_text={show_text} />
      )}

      {diamond.DiamondSource === DIAMOND_SOURCE_RECYCLED && (
        <RecycleIcon size={size} show_text={show_text} />
      )}

      <DomLink
        to={getHelpLink(diamond.Collection)}
        target="_blank"
        rel="noreferrer"
      >
        <HelpIcon className="help-icon question-mark" />
      </DomLink>
    </Stack>
  );
}
